import type { ReactElement } from 'react';
import type { PieChartArc } from './piechart-types';
interface PieChartBackgroundBloomProps {
    arc: PieChartArc | undefined;
}
export function PieChartBackgroundBloom({ arc, }: PieChartBackgroundBloomProps): ReactElement | null {
    if (!arc)
        return null;
    return (
      <div style={{
            position: 'absolute',
            top: '-20%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80%',
            height: '80%',
            backgroundImage: `radial-gradient(ellipse at top, ${arc.color}15, transparent 70%)`,
            pointerEvents: 'none',
            zIndex: 0,
        }}/>
    );
}
